import React, { useRef } from "react";
import Banner from "./Banner/Banner";
import Learn from "./Learn/Learn";
import Navbar from "../Navbar/Navbar";
import Innovation from "./Innovation/Innovation.js";
import ITES from "./ITES/ITES.js";
import Courses from "./Courses/Courses.js";
import Skills from "./Skills/Skills.js";
import Testimonial from "./Testimonial/Testimonial.js";
import Pictures from "./Pictures/Pictures.js";
import Questions from "./Questions/Questions.js";
import Contact from "./Contact/Contact.js";
import Footer from "../Footer/Footer.js";
import About from "./About/About.js";
import NavMUI from "../Navbar/NavMUI.js";
import Video from "./Video/Video.js";
import LogoDiv from "./Contact/LogoDiv.js";
import Addr from "./Contact/Addr.js";

function Landing() {
  const course = useRef(null)
  const contact = useRef(null)
  const contactus = useRef(null)
  const aboutus = useRef(null)
  const home = useRef(null)

  const executeScrollCourse = () => course.current ? course.current.scrollIntoView() : null
  const executeScrollContact = () => (contact.current ? contactfocus() : null)
  const executeScrollAboutus = () => (aboutus.current ? aboutus.current.scrollIntoView() : null)
  const executeScrollHome = () => (home.current ? home.current.scrollIntoView() : null)

  const contactfocus = () => {
    contactus.current.scrollIntoView()
    setTimeout(() => {
      contact.current.focus()
    }, 700)
  }

  return (
    <>
      <NavMUI
        executeScroll={executeScrollCourse}
        executeScrollContact={executeScrollContact}
        executeScrollAboutus={executeScrollAboutus}
      />
      <div className="landing" ref={home}>
        <div className="page-content">
          <Banner executeScroll={executeScrollCourse} />
          <Learn />
          <Innovation executeScrollContact={executeScrollContact} />
        </div>
        <Courses myRef={course} />
        <div className="page-content">
          <Skills />
          <ITES />
          <Testimonial />
        </div>
        <Pictures />
        <div className="page-content">
          <Video />
          <About myref={aboutus} />
        </div>
        <Questions executeScrollContact={executeScrollContact} />
        <Contact myRef={contact} mainref={contactus} />
        <Addr />
        {/* <LogoDiv /> */}
      </div>
      <Footer
        executeScroll={executeScrollCourse}
        executeScrollContact={executeScrollContact}
        executeScrollAboutus={executeScrollAboutus}
        executeScrollHome={executeScrollHome}
      />
    </>
  );
}

export default Landing;
